export default __webpack_public_path__ + "static/tarzana-small-logo-43d73b2334d5eb602190643084d0ddc1.png";